import { Component, ViewChild } from '@angular/core';
import { Nav, Platform, MenuController, ActionSheetController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { AppConfig } from '../providers/appconfig';
import { InundationProvider } from '../providers/inundation-provider';
import { WaveProvider } from '../providers/wave-provider';
import { WaterlevelProvider } from '../providers/waterlevel-provider';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;
  // rootPage:any = "InundationTabsPage";
  rootPage:any = "HomePage";
  pages: Array<{title: string, component: any}>;

  constructor(public platform: Platform, public statusBar: StatusBar,
              public splashScreen: SplashScreen,
              public appConfig: AppConfig,
              public menuCtrl: MenuController,
              public actionSheetCtrl: ActionSheetController,
              public inundationService: InundationProvider,
              public waveService: WaveProvider,
              public waterlevelService: WaterlevelProvider) {

    this.initializeApp();

    // used for an example of ngFor and navigation
    this.pages = [
      { title: 'NERACOOS Coastal Flooding Toolkit', component: "HomePage" },
      { title: 'Beach Erosion and Flooding Forecast', component: "InundationTabsPage" },
      { title: 'Buoy Observations', component: "WaveTabsPage" },
      { title: 'Water Level', component: "TideTabsPage" },
      { title: 'Observation and Forecast Map', component: "AssetMapPage" }
    ];
  }

  navigateToSurgeLocation() {
  };

  initializeApp() {
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      this.statusBar.styleDefault();
      this.splashScreen.hide();
      // getting preferences is asynchronous so do it now.
      this.appConfig.updateUserPreferences(0);
      // subscribe to the initialdata loaded event
      this.inundationService.inundProvUpdates().subscribe( event_obj => {
        console.log( event_obj.name ) ;
        if ( event_obj.name == "initial_data_loaded" ) {
          // now we have a splash page
          // this.menuCtrl.open();
        }
      });
      // read in the initial locations and a few other things.
      this.inundationService.initializeData();
      // done from the service after the observable is initialized
      // or rather I'd like to do that but the observable doesn't want to work
      this.waveService.initializeData(true);
      this.waterlevelService.initializeData(true);
      // moved this to initializeData
      // this.menuCtrl.open();
    });
  }

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    // let selectModal = this.modalCtrl.create(SelectestabPage);
    // NOTE: eventually check the page here to provide different selections
    this.inundationService.openPage(page,this.nav) ;
  }
  chooseMonitoringLocation(mlId) {
    this.appConfig.mainMenuTriggered = true ;
    this.appConfig.setLocationSelected( this.inundationService, mlId ) ;
    // do I want to do this every time?
    // this.nav.setRoot(page.component);
    this.inundationService.forecast_ready = false ;
    this.inundationService.getStocktonForecast(false, this.appConfig.getLocationSelected(), false);
    let activeView: any = this.nav.getActive();
    if ( activeView.component.name == "HomePage" ) {
      this.nav.setRoot("InundationTabsPage");
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts